function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.459473,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8755 11.8438H18.1255C14.7479 11.8438 12.0005 14.5912 12.0005 17.9688V29.7812C12.0005 33.1588 14.7479 35.9062 18.1255 35.9062C19.4467 35.9062 20.6892 36.4225 21.6255 37.3543L22.7805 38.5049C23.6424 39.3668 24.7843 39.8394 26.0005 39.8394C27.2167 39.8394 28.363 39.3668 29.2205 38.5049L30.3755 37.3499C31.3117 36.4137 32.5543 35.9018 33.8755 35.9018C37.253 35.9018 40.0005 33.1544 40.0005 29.7768V17.9643C40.0005 14.5868 37.253 11.8394 33.8755 11.8394V11.8438ZM36.5005 29.7812C36.5005 31.2293 35.3235 32.4062 33.8755 32.4062C31.6179 32.4062 29.4961 33.2857 27.8992 34.8826L26.7442 36.0376C26.3418 36.44 25.6549 36.4444 25.2523 36.0376L24.0973 34.887C22.5004 33.2901 20.3785 32.4107 18.121 32.4107C16.6729 32.4107 15.496 31.2337 15.496 29.7857V17.9732C15.496 16.5251 16.6729 15.3482 18.121 15.3482H33.871C35.3191 15.3482 36.496 16.5251 36.496 17.9732V29.7857L36.5005 29.7812Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3755 21.4687C23.3755 22.4352 22.5919 23.2187 21.6255 23.2187C20.659 23.2187 19.8755 22.4352 19.8755 21.4687C19.8755 20.5023 20.659 19.7188 21.6255 19.7188C22.5919 19.7188 23.3755 20.5023 23.3755 21.4687Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1255 21.4687C32.1255 22.4352 31.3419 23.2187 30.3755 23.2187C29.409 23.2187 28.6255 22.4352 28.6255 21.4687C28.6255 20.5023 29.409 19.7188 30.3755 19.7188C31.3419 19.7188 32.1255 20.5023 32.1255 21.4687Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2384 26.2067C26.556 26.8891 25.4447 26.8891 24.7621 26.2067C24.0796 25.5242 22.9728 25.5242 22.2858 26.2067C21.6033 26.8891 21.6033 28.0004 22.2858 28.683C23.3094 29.7067 24.6527 30.2186 26.0001 30.2186C27.3477 30.2186 28.6908 29.7068 29.7145 28.683C30.397 28.0005 30.397 26.8937 29.7145 26.2067C29.032 25.5242 27.9252 25.5242 27.2382 26.2067H27.2384Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetup);
export default __webpack_public_path__ + "static/media/meetup.da68ea815d978ce3f511e592721e7721.svg";
export { ForwardRef as ReactComponent };